import { Component } from '@angular/core';
import { TreeNode } from 'primeng/api';
import { NodeService } from '../../Services/api-nodeservice';
import { Api } from '../../Model/api-model';
import { Router } from '@angular/router';

@Component({
  selector: 'announcement-support',
  templateUrl: './announcement.component.html'
})
export class AnnouncementComponent{

    constructor(private nodeService: NodeService,private router: Router) {
      localStorage.setItem("is_cuurent_nav_aem","y");
     }


    ngAfterViewInit() {
      // Hack: Scrolls to top of Page after page view initialized
      let top = document.getElementById('top');
      if (top !== null) {
        top.scrollIntoView();
        top = null;
      }
    }

}